import { Shop } from "@header/types";

type GetNavData = (shops: Shop[]) => {
  primaryNav: Shop[];
  seasonalNav: Shop[];
};

export const getNavData: GetNavData = (shops) => {
  const seasonalNav: Shop[] = [];
  let todaysDeals: Shop | undefined = undefined;
  let onePassItem: Shop | undefined = undefined;
  const primaryNav: Shop[] = [...shops].filter((shop) => {
    if (shop.slug === "today-s-deals") {
      todaysDeals = shop;
      return false;
    }

    if (shop.slug === "onepass") {
      onePassItem = shop;
      return false;
    }

    if (shop.pinToTop) {
      seasonalNav.push(shop);
      return false;
    }
    return shop.shopNavigationGroups.length > 0;
  });

  if (todaysDeals) {
    seasonalNav.unshift(todaysDeals);
  }

  if (onePassItem) {
    seasonalNav.unshift(onePassItem);
  }

  return {
    primaryNav,
    seasonalNav,
  };
};
